var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRuller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3388 16.7141L16.058 17.9949L15.2001 17.137L16.4809 15.8562L14.1368 13.512L12.8559 14.7928L11.998 13.9349L13.2788 12.6541L10.9347 10.3099L9.65384 11.5908L8.79592 10.7328L10.0768 9.452L7.72051 7.09575L6.43967 8.37659L5.58176 7.51867L6.86259 6.23783L4.51842 3.89367L3.23759 5.1745L2.37967 4.31659L3.66051 3.03575L0.833008 0.208252V17.1249C0.833008 18.4541 1.92051 19.5416 3.24967 19.5416H20.1663L17.3388 16.7141ZM4.45801 15.9166V8.95658L11.418 15.9166H4.45801Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuller);
export default __webpack_public_path__ + "static/media/ruller.b8cd02f7a313d9d6d16b1d1fa9df28b1.svg";
export { ForwardRef as ReactComponent };